import { replace, split } from 'lodash';

export const KAPITI_PRODUCT_CODE = '1000';
export const CREDIT_CARD = 'credit_card';
export const UPPER_THRESHOLD = 'upper_threshold';
export const LOWER_THRESHOLD = 'lower_threshold';
export const PROJECTION = 'projection';
export const UNFORMAT_CREDIT_CARD_NUMBER = (accountDetails) => {
  const amendedCreditCardNumber = replace(accountDetails.number, '************', 'xxxxxxxxxxxx');
  return split(amendedCreditCardNumber, '-');
};
export const BALANCE_ALERT = 'Balance alerts';
export const SWEEP_ALERT = 'Sweep alerts';
export const TRANSACTION_ALERT = 'Transaction alerts';
export const AMOUNT_LIMIT = 999999.0;
export const AMOUNT_LIMIT_MINIMUM = -99999.0;
export const DEFAULT_LOW_BAL = 50.0;
export const DEFAULT_HIGH_BAL = 150.0;
export const DEFAULT_TRANSACTION_BAL = 100.0;
export const SWEEP_ERROR_STATUS = 404;
export const UPGRADE_THRESHOLD_AMOUNT = 100;
export const FIX_DECIMAL_BY_TWO = 2;
export const ALERT = 'alert';
export const INCOMING_TRANSACTION_LIMIT = 99.99;
export const ARRANGED = 'arranged';
export const UNARRANGED = 'unarranged';

export const ROLE_ENDORSER = 'ENDORSER';
export const YOUTH_ACCOUNT_PRODUCT_CODES = ['741', '742'];
